"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _ethereumjsUtil = require("ethereumjs-util");

var _addressUtils = require("./helpers/addressUtils");

/* eslint-disable */
const toBuffer = v => {
  if ((0, _ethereumjsUtil.isHexString)(v)) {
    return (0, _ethereumjsUtil.toBuffer)(v);
  }

  return Buffer.from(v);
};

class WalletInterface {
  constructor(key) {
    let isPub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let identifier = arguments.length > 2 ? arguments[2] : undefined;
    let nick = arguments.length > 3 ? arguments[3] : undefined;
    let keystore = arguments.length > 4 ? arguments[4] : undefined;
    this.nickname = nick !== null && nick !== '' ? nick : '';
    this.keystore = keystore !== null && keystore !== '' ? keystore : '';
    this.identifier = identifier;

    if (!isPub) {
      const _privKey = Buffer.isBuffer(key) ? key : (0, _utils.getBufferFromHex)((0, _utils.sanitizeHex)(key));

      if (!(0, _ethereumjsUtil.isValidPrivate)(_privKey)) throw new Error('Private key does not satisfy the curve requirements (ie. it is invalid)');
      this.privateKey = _privKey;
      this.publicKey = (0, _ethereumjsUtil.privateToPublic)(_privKey);
      this.isPubOnly = false;
    } else {
      const _pubKey = Buffer.isBuffer(key) ? key : (0, _utils.getBufferFromHex)(key);

      if (_pubKey.length !== 20 && !(0, _ethereumjsUtil.isValidPublic)(_pubKey, true)) throw new Error('Invalid public key');
      if (_pubKey.length === 20) this.isAddress = true;
      this.publicKey = _pubKey;
      this.isPubOnly = true;
    }
  }

  getPrivateKey() {
    if (this.isPubOnly) throw new Error('public key only wallet');
    return this.privateKey;
  }

  getPrivateKeyString() {
    if (this.isPubOnly) throw new Error('public key only wallet');
    return (0, _ethereumjsUtil.bufferToHex)(this.getPrivateKey());
  }

  getNickname() {
    if (this.nickname === '') return '';
    return this.nickname;
  }

  getKeystore() {
    if (this.keystore === '') return '';
    return this.keystore;
  }

  getPublicKey() {
    if (this.isAddress) throw new Error('Address only wallet');
    return this.publicKey;
  }

  getPublicKeyString() {
    return (0, _ethereumjsUtil.bufferToHex)(this.getPublicKey());
  }

  getAddress() {
    if (this.isAddress) return this.publicKey;
    return (0, _ethereumjsUtil.publicToAddress)(this.publicKey, true);
  }

  getAddressString() {
    return (0, _ethereumjsUtil.bufferToHex)(this.getAddress());
  }

  getChecksumAddressString() {
    return (0, _addressUtils.toChecksumAddress)(this.getAddressString());
  }

  signTransaction(txParams, signer) {
    if (this.isPubOnly && typeof signer !== 'function') throw new Error('public key only wallets needs a signer');
    return new Promise((resolve, reject) => {
      signer(txParams).then(resolve).catch(reject); // }
    });
  }

  signMessage(msg, signer) {
    if (this.isPubOnly && typeof signer !== 'function') throw new Error('public key only wallets needs a signer');
    return new Promise((resolve, reject) => {
      if (!this.isPubOnly) {
        const msgHash = (0, _ethereumjsUtil.hashPersonalMessage)(toBuffer(msg));
        const signed = (0, _ethereumjsUtil.ecsign)(msgHash, this.privateKey);
        resolve(Buffer.concat([Buffer.from(signed.r), Buffer.from(signed.s), Buffer.from([signed.v])]));
      } else {
        signer(msg).then(resolve).catch(reject);
      }
    });
  }

}

var _default = WalletInterface;
exports.default = _default;